// extracted by css-extract-rspack-plugin
export default {"sidebar":"IWcaC","header":"SaLpN","scrollArea":"O6lzZ"};